module.exports = __webpack_public_path__ + "img/z-idcardbg2.5f1bd6c6.png";